/**
 * Example configuration for Clustersie Theme
 * Copy this configuration and modify according to your needs
 */

export const clustersieConfig = {
  // Basic theme configuration
  theme: {
    type: "clustersie",
    subdomain: "main" // main, coffee, fisheries, fruit, bittermelon, halal, mulberry
  },

  // API configuration
  api: {
    baseURL: process.env.NUXT_PUBLIC_API_URL || 'https://api.example.com',
    notificationEndpoint: '/api/notify'
  },

  // Domain configuration
  domain: {
    production: process.env.NUXT_PUBLIC_DOMAIN || 'example.com',
    development: 'localhost:3000'
  },

  // Email configuration
  email: {
    enabled: true,
    provider: 'sendgrid', // sendgrid, mailgun, smtp
    templates: {
      notification: 'coming-soon-notification'
    }
  },

  // Analytics configuration
  analytics: {
    googleAnalytics: process.env.NUXT_PUBLIC_GA_ID,
    facebookPixel: process.env.NUXT_PUBLIC_FB_PIXEL_ID
  },

  // Social media links (global)
  social: {
    facebook: 'https://facebook.com/yourpage',
    twitter: 'https://twitter.com/yourhandle',
    instagram: 'https://instagram.com/yourhandle',
    linkedin: 'https://linkedin.com/company/yourcompany'
  },

  // Site-specific overrides
  sites: {
    main: {
      launchDate: '2025-12-01',
      social: {
        facebook: 'https://facebook.com/mainpage'
      }
    },
    coffee: {
      launchDate: '2025-11-15',
      social: {
        facebook: 'https://facebook.com/coffeecluster'
      }
    },
    fisheries: {
      launchDate: '2025-10-30',
      social: {
        facebook: 'https://facebook.com/fisheriescluster'
      }
    },
    fruit: {
      launchDate: '2025-11-01'
    },
    bittermelon: {
      launchDate: '2025-12-15'
    },
    halal: {
      launchDate: '2025-11-20'
    },
    mulberry: {
      launchDate: '2025-12-01'
    }
  }
}